<template>
  <v-card>
    <v-card-title>CARTILLA MEDICA</v-card-title>
    <v-card-text>
      <v-row>
        <v-col v-if="!planReadonly" md="2" cols="12" 
          ><Cboplanes v-model="idplan" :readonly="planReadonly"></Cboplanes
        ></v-col>
        <v-col md="3" cols="12">
          <v-autocomplete
            outlined
            dense
            v-model="idespecialidad"
            :items="especialidades"
            item-text="descripcion_especialidad"
            item-value="id_especialidad"
            label="Especialidad"
            persistent-hint
            hide-details
          ></v-autocomplete>
        </v-col>
        <v-col md="3" cols="12">
          <v-autocomplete
            outlined
            dense
            v-model="idprovincia"
            :items="provincias"
            item-text="Descripcion_provincia"
            item-value="id_provincia"
            label="Provincia"
            persistent-hint
            hide-details
          ></v-autocomplete>
        </v-col>
        <v-col md="3" cols="12">
          <v-autocomplete
            outlined
            dense
            v-model="localidad"
            :items="localidades"
            item-text="descripcion_localidad"
            item-value="descripcion_localidad"
            label="Localidad"
            persistent-hint
            hide-details
          ></v-autocomplete>
        </v-col>
        <v-col md="1" cols="12">
          <v-btn
            :disabled="domicilios?.length == 0"
            color="success"
            :loading="cargando"
            @click="exportar"
          >
            <v-icon>mdi-file-excel</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <div v-if="cargando" class="text-center ma-5">
        <h2 class="ma-5">Espere</h2>
        <v-progress-circular
          :size="80"
          color="green"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-if="domicilios">
        <v-row>
          <v-col>
            <h4>{{ domicilios.length }} resultados</h4>
          </v-col>
        </v-row>
        <v-row v-if="!cargando">
          <v-col
            md="3"
            cols="12"
            v-for="domicilio in domicilios"
            :key="domicilio.id"
          >
            <h4 class="green--text text--lighten-2 font-italic">
              {{ domicilio.Efector }}
            </h4>
            <h4>{{ domicilio.domicilio }}</h4>
            <h4>{{ filtrarLocalidad(domicilio.id_localidad) }}</h4>
            <h4>{{ domicilio.telefono }}</h4>
            <h4 v-if="!planReadonly">
              <span v-if="domicilio?.planes?.length > 0">Planes: </span>
              <span v-for="plan in domicilio?.planes" :key="plan">
                {{ descripcionplan(plan) }}
              </span>
            </h4>
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Cboplanes from '@/components/Planes/ComboConTodos'
import API from '../../lib/API'
import { mapState } from 'vuex'

import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

export default {
  props: {
    id_plan: Number
  },
  data() {
    return {
      cargando: false,
      idplan: -1,
      idespecialidad: 0,
      idprovincia: 0,
      localidad: '-- SELECCIONE --'
    }
  },
  components: {
    Cboplanes
  },
  computed: {
    ...mapState('localidades', ['Lista']),
    ...mapState('provincias', { Listaprovincias: 'Lista' }),
    ...mapState('planes', { Listaplanes: 'Lista' }),
    planReadonly() {
      return this.id_plan != undefined
    },
    loc() {
      return this.localidad.replace('-- SELECCIONE --', '') + '=='
    },
    especialidades() {
      let ret = []
      if (this.getespecialidades) {
        ret = this.getespecialidades
        ret.unshift({
          id_especialidad: 0,
          descripcion_especialidad: '-- SELECCIONE --'
        })
      }
      return ret
    },
    provincias() {
      let ret = []
      if (this.getprovincias) {
        ret = this.getprovincias
        ret.unshift({
          id_provincia: 0,
          Descripcion_provincia: '-- SELECCIONE --'
        })
      }
      return ret
    },
    localidades() {
      let ret = []
      if (this.getlocalidades) {
        ret = this.getlocalidades
        ret.unshift({
          id_localidad: 0,
          descripcion_localidad: '-- SELECCIONE --',
          codigo_postal: '1000',
          id_seccional: 1,
          id_provincia: 1
        })
      }
      return ret
    }
  },
  asyncComputed: {
    getespecialidades: {
      get() {
        let ret = []
        if (this.idplan > -1) {
          ret = API.Especialidades.traerParaCartilla(
            this.idplan,
            0,
            this.idprovincia,
            this.loc
          ).then((response) => (ret = response))
        }
        return ret
      }
    },
    getprovincias: {
      get() {
        let ret = []
        if (this.idplan > -1) {
          ret = API.Provincias.traerParaCartilla(
            this.idplan,
            this.idespecialidad,
            0,
            this.loc
          ).then((response) => (ret = response))
        }
        return ret
      }
    },
    getlocalidades: {
      get() {
        let ret = []
        if (this.idplan > -1) {
          ret = API.Localidades.traerParaCartilla(
            this.idplan,
            this.idespecialidad,
            this.idprovincia,
            '=='
          ).then((response) => (ret = response))
        }
        return ret
      }
    },
    domicilios: {
      async get() {
        let ret = []
        if (this.idplan > -1) {
          this.cargando = true
          ret = await API.domiciliosprofesionales.traerParaCartilla(
            this.idplan,
            this.idespecialidad,
            this.idprovincia,
            this.loc
          )
          // .then(function(response) {
          //   ret = response;
          this.cargando = false
          //   return 0;
          // });
        }
        return ret
      }
    }
  },
  methods: {
    filtrarLocalidad(id) {
      let ret = ''
      let loc = this.localidades.filter((x) => x.id_localidad == id)

      if (loc.length > 0) {
        ret = loc[0].descripcion_localidad
      }

      return ret
    },
    descripcionplan(id) {
      let ret = ''
      let plan = this.Listaplanes.filter((x) => x.id_plan == id)
      if (plan.length > 0) {
        ret = plan[0].Descripcion_plan
      }
      return ret
    },
    async exportar() {
      const wb = new ExcelJS.Workbook()
      const ws = wb.addWorksheet()

      ws.addRow(['Cartilla'])
      ws.addRow(['Filtros:'])

      ws.addRow([
        this.idplan !== 0
          ? 'Plan: ' +
            this.Listaplanes?.find((x) => x.id_plan == this.idplan)
              .Descripcion_plan
          : 'Plan: Todos'
      ])
      if (this.idespecialidad) {
        ws.addRow([
          'Especialidad: ' +
            this.especialidades.find(
              (x) => x.id_especialidad == this.idespecialidad
            ).descripcion_especialidad
        ])
      }
      if (this.idprovincia) {
        ws.addRow([
          'Provincia: ' +
            this.provincias.find((x) => x.id_provincia == this.idprovincia)
              .Descripcion_provincia
        ])
      }
      if (this.localidad != '-- SELECCIONE --') {
        ws.addRow(['Localidad: ' + this.localidad])
      }

      let columns = ['Efector ', 'Domicilio', 'Localidad', 'Telefono', 'Planes']

      let columnas = []
      for (let columna of columns) {
        columnas.push({ name: columna })
      }
      let rows = []
      for (let domicilio of this.domicilios) {
        const loc = this.Lista.filter(
          (x) => x.id_localidad == domicilio.id_localidad
        )
        const descripcion_localidad = loc[0]?.descripcion_localidad || ''
        let planes = 'Planes: '
        if (domicilio?.planes?.length > 0) {
          for (let plan of domicilio?.planes) {
            planes += this.descripcionplan(plan) + ', '
          }
        }
        rows.push([
          domicilio.Efector,
          domicilio.domicilio,
          descripcion_localidad,
          domicilio.telefono,
          planes
        ])
      }

      ws.addTable({
        name: 'MyTable',
        ref: 'A8',
        headerRow: true,
        totalsRow: false,
        style: {
          theme: 'TableStyleMedium9',
          showRowStripes: true
        },
        columns: columnas,
        rows: rows
      })

      const buf = await wb.xlsx.writeBuffer()
      saveAs(new Blob([buf]), 'cartilla.xlsx')
      // await wb.xlsx.writeBuffer().then((buf) => {
      //   saveAs(new Blob([buf]), 'cartilla.xlsx')
      // })
    },
    filtrarProvincia(id) {
      let ret = ''
      let prov = this.Listaprovincias.filter((x) => x.id_provincia == id)
      if (prov != undefined) {
        if (prov.length > 0) {
          ret = prov[0].Descripcion_provincia
        }
      }
      return ret
    }
  },
  mounted() {
    if (this.id_plan) {
      this.idplan = this.id_plan
    }
  },
  watch: {
    id_plan() {
      if (this.id_plan) {
        this.idplan = this.id_plan
      }
    }
  }
}
</script>

<style></style>
